/* eslint-disable @typescript-eslint/no-explicit-any */
import { getCookie } from "./authService"; 
import { FOLIO_API_URL, NODE_API_URL } from "./gloableVariables";

type BaseUrlType = "base1" | "base2" | "none"; // Extend if needed

/**
 * Get the current auth token or fallback token.
 * jitendrasikligar12@gmail.com
 * Aman - 8950631943
 */
function getAuthToken() {
  // return getCookie("authToken") || `eyJpdiI6ImlydS81b0pZdVJrMjhDN2FWNktUWnc9PSIsInZhbHVlIjoiN05Ga3I3Y1VZNC9TMWNEQkpDek9ITnB3ekt4UDVZYXc2cjAyN3Bhc0ZFRnF0NGhSbzJEeVBvT1A5TlVhN3haTW1zS2gvVFZtVlpzRHpGcS9RTEdkRlFON0RQZGpLOENCUnlFTVo1SzJMUjdDbEloR1ZWY1VLK3JINWhVT0VrakUiLCJtYWMiOiI4MTIzNDI0M2RmYWU2MTZjMTZlODFiN2JhM2YyZGFjM2NmODI4MWEzMGVkY2M1OTFjZTc4ZjVlMzMzNjI4ZjdiIiwidGFnIjoiIn0=`;
  
  // Aish
  // return getCookie("authToken") || `eyJpdiI6IjJOZlFHOFNlV1ZYZDdGa0hHUk5yUHc9PSIsInZhbHVlIjoic09weTRxbGZiN1UzNGdpNUdhbllHclVPQlZ0NGxFZ2ozNUJQTjV6cU9XRktSSllQQm91VlFXd2NoT1BIY3lNMkNnSzJ1SnVKck9xRUIrVzZTUDUxVVFSQkxTeXlQTkp0TUJuYjZWdzhzU1dmZzhLSCs4bmtKRUVKYytvZmNvbGoiLCJtYWMiOiJkMDA4YjY2ZjgwYTlmZjZiZDYyZmJmNzk2ODRhZGI0ZGNlMmE0NDI2Y2U0YTEwNWMyMmIxN2YxOTE3NzZiZGVlIiwidGFnIjoiIn0=`;

  // Jitendra sir login
  // return getCookie("authToken") || `eyJpdiI6IjdOMzlwV29FVFd3NjNnODFZRDZhYWc9PSIsInZhbHVlIjoiMjVDZ3hNMkhDVTYrRnBoRFBlTllHT2FzTVY2SGZUVkM0cXdqUC8vaWlPK081QyswOHJzckNsa3RWSG93NkdrV2huTUd0ZURiSHVkVDB1LzB6YzRreHRuSUZxblg4d2hjSXVmaTFyYmZITFdyZ2hGd3oyYWd0RWVCekFGelpKaWQiLCJtYWMiOiJkNWIxNzVjYWFhMGQwMzBlYjBhYmQ1YzU2MzMzNjlhZGU3NDAyMTYwMTVhMGQ0NzQ4MDE5MDE3YzdhMGQ1Y2ZjIiwidGFnIjoiIn0=`;
  
  // Ravi sir login
  // return getCookie("authToken") || `eyJpdiI6IkdSNkdQUStRWGZZbXBjYVVmNFpLZFE9PSIsInZhbHVlIjoiM0NUTWJCVGQyZTVidVFOWVBOMGZQbHA5cXNoblIycnBscDNGSVJGZHlrVUVYaHk3ZWNJUVhOOXJBQ2t3Syt0U1kzV3NQeTNUOWtZOXM2N05LVW9RSGFlYmsrUllraVkzcmRyWUErdk1Ta3FWaU1Sbll0c0FheE5lR3l2OHEvZ0wiLCJtYWMiOiJkMmFjMTE1YmY0OTU5ZjNmN2YxZmI0Njg0YmM1ZjgwYjJjZDNmYWFkNjIxMmE1OWQ4M2Q2NGRkMDg2OTA5ZTA5IiwidGFnIjoiIn0=`;

  return getCookie("authToken");
}

interface RequestOptions extends RequestInit {
  headers?: HeadersInit;
  base?: BaseUrlType | string; // Accept literal OR dynamic user-defined base
  authToken?: string; // Optional auth token from the user
  useAuth?: boolean;
}

/**
 * Chooses the base URL based on the key or string.
 */
function getBaseUrl(base: string = "base1"): string {
  switch (base) {
    case "base1":
      return FOLIO_API_URL;
    case "base2":
      return NODE_API_URL;
    case "none":
      return ""; // No base URL
    default:
      // You can also validate if this is a full URL here
      if (base.startsWith("http")) return base;
      console.error(`[getBaseUrl] Unknown base: "${base}", falling back to FOLIO_API_URL`);
      return FOLIO_API_URL;
  }
}

/**
 * Core request function that all other helpers call.
 */
async function request<T>(endpoint: string, options: RequestOptions = {}): Promise<T> {
  const { headers, base = "base1", authToken, useAuth = true, ...rest } = options;
  const baseUrl = getBaseUrl(base);

  // const token = authToken || getAuthToken();
  const token = useAuth ? authToken || getAuthToken() : (options?.authToken ? options?.authToken : null);

  const isFormData = typeof FormData !== "undefined" && rest.body instanceof FormData;

  const response = await fetch(`${baseUrl}${endpoint}`, {
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(useAuth && token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
    ...rest,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    let errorMessage = errorData.message || `API request failed with status ${response.status}`;
    if (errorData.errors && typeof errorData.errors === "object") {
      const firstVal = Object.values(errorData.errors)[0];
      if (Array.isArray(firstVal) && firstVal.length > 0) {
        errorMessage = firstVal[0] as string;
      } else if (typeof firstVal === "string") {
        errorMessage = firstVal;
      }
    }
    throw new Error(errorMessage);
  }
  return response.json();
}

/**
 * GET request.
 */
export async function apiGet<T = any>(endpoint: string, options?: RequestOptions): Promise<T> {
  return request<T>(endpoint, {
    ...options,
    method: "GET",
  });
}

/**
 * POST request.
 */
export async function apiPost<T = any>(endpoint: string, body: any, options?: RequestOptions): Promise<T> {
  const isFormData = typeof FormData !== "undefined" && body instanceof FormData;
  return request<T>(endpoint, {
    ...options,
    method: "POST",
    body: isFormData ? body : JSON.stringify(body),
  });
}

/**
 * PUT request.
 */
export async function apiPut<T = any>(endpoint: string, body: any, options?: RequestOptions): Promise<T> {
  const isFormData = typeof FormData !== "undefined" && body instanceof FormData;
  return request<T>(endpoint, {
    ...options,
    method: "PUT",
    body: isFormData ? body : JSON.stringify(body),
  });
}

/**
 * DELETE request.
 */
export async function apiDelete<T = any>(endpoint: string, options?: RequestOptions): Promise<T> {
  return request<T>(endpoint, {
    ...options,
    method: "DELETE",
  });
}
